import React from 'react';

import styled from 'styled-components';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import ko from 'date-fns/locale/ko';
// 만약 위 경로가 안 된다면 아래 시도
import { ko } from 'date-fns/locale';

registerLocale('ko', ko);

const Wrapper = styled.div`
  width: 100%;

  .react-datepicker-wrapper {
    width: 100%;

    input {
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      height: calc(1.5em + 1.25rem + 5px);
      font-size: 0.875rem;
      padding: 0.625rem 0.75rem;
      color: #8898aa;
      line-height: 1.5;
      background-color: #fff;
      background-clip: padding-box;
      box-shadow: 0 3px 2px rgb(233 236 239 / 5%);
      width: 100%;
    }
  }

  .react-datepicker__month-container {
    .react-datepicker__header {
      background-color: #ffffff;

      .react-datepicker__current-month,
      .react-datepicker__day-names > div {
        color: #525f7f;
      }
    }
  }

  .react-datepicker-popper.custom-datepicker-popper {
    inset: unset;
    translate: unset;
    padding-top: 0;

    .react-datepicker__day {
      color: #525f7f;
    }

    .react-datepicker__day--keyboard-selected {
      color: #ffffff;
      border-radius: 50%;
      background-color: #11cdef;
    }

    .react-datepicker__day.react-datepicker__day--outside-month {
      color: #dee2e6;
    }

    .react-datepicker__day.react-datepicker__day--selected {
      background-color: #5e72e4;
      border-radius: 50%;
      color: #ffffff;
    }

    .react-datepicker__day--disabled {
      color: #8898aa;
    }
  }
`;

function ReactDatePicker({ myDate, setMyDate, required = false, maxDate = null, minDate = null }) {
  return (
    <Wrapper>
      <DatePicker
        dateFormat="yyyy-MM-dd"
        locale="ko"
        selected={myDate}
        onChange={(date) => setMyDate(date)}
        onSelect={(date) => setMyDate(date)}
        maxDate={maxDate}
        minDate={minDate}
        popperClassName="custom-datepicker-popper"
        showPopperArrow={false}
        required={required}
        dateFormatCalendar="yyyy LLLL"
      />
    </Wrapper>
  );
}

export default ReactDatePicker;
